export enum QuestionImageSize {
    width360 = '360x',
    width720 = '720x',
    width1280 = '1280x',
    width2560 = '2560x',
    cropped56x40 = '56x40',
    cropped324x180 = '324x180',
    cropped200x256 = '200x256',
    cropped400x512 = '400x512',
}

export enum QuestionType {
    Stars = 'stars',
    String = 'string',
    Radio = 'radio',
    Checkbox = 'checkbox',
    Dropdown = 'dropdown',
    Boolean = 'boolean',
    Matrix = 'matrix',
    Suggest = 'suggest',
    File = 'file',
    Payment = 'payment',
    Integer = 'integer',
    Date = 'date',
    DateRange = 'daterange',
    Captcha = 'captcha',
    Comment = 'comment',
    OneRow = 'onerow',
}

export enum DataSource {
    Choice = 'survey_question_choice',
    Matrix = 'survey_question_matrix_choice',
    Country = 'country',
    City = 'city',
    University = 'university',
    Address = 'address',
    Email = 'user_email_list',
    Wiki = 'wiki_table_source',
    Gender = 'gender',
    DirUser = 'dir_user',
    DirDepartment = 'dir_department',
    DirGroup = 'dir_group',
    WebMasterSite = 'web_master_site',
    MusicGenre = 'music_genre',
    YtTable = 'yt_table_source',
    StaffLogin = 'staff_login',
    StaffGroup = 'staff_group',
    StaffOrganization = 'staff_organization',
    StaffOffice = 'staff_office',
    ABC = 'abc_service',
}
